export function getToken() {
  return localStorage.getItem("token");
}

function decodeBase64Url(value) {
  const normalized = value.replace(/-/g, "+").replace(/_/g, "/");
  const padded = normalized + "=".repeat((4 - (normalized.length % 4)) % 4);
  return atob(padded);
}

export function getSession() {
  const token = getToken();
  if (!token) {
    return null;
  }

  try {
    const parts = token.split(".");
    if (parts.length < 2) {
      return null;
    }

    const payload = JSON.parse(decodeBase64Url(parts[1]));
    return {
      token,
      userId: payload.sub,
      tipoId: payload.tipo_id,
      workspaces: Array.isArray(payload.workspaces) ? payload.workspaces : [],
    };
  } catch (_err) {
    return null;
  }
}

export function isAdmin(session) {
  return Boolean(session && Number(session.tipoId) === 1);
}

export function isWorkspaceAdmin(session) {
  if (!session) {
    return false;
  }
  return session.workspaces.some(ws => Number(ws.role_id) === 1);
}

export function hasWorkspaceAccess(session) {
  if (!session) {
    return false;
  }
  return session.workspaces.some(ws => [1, 2].includes(Number(ws.role_id)));
}

export function canManagePlanejamentos(session) {
  return isAdmin(session) || isWorkspaceAdmin(session);
}

export function canManageWorkspaces(session) {
  return isAdmin(session) || isWorkspaceAdmin(session);
}
